import type { QueryClient, QueryKey } from '@tanstack/react-query';

import { statusBoardQueryKeys } from '@/core/query-keys/status-board-query-keys';

/** Keys Home PTR and ionViewWillEnter share (DEV-441 / DEV-442). */
export const DASHBOARD_REFRESH_QUERY_KEYS: readonly QueryKey[] = [
  statusBoardQueryKeys.root,
  ['notifications'],
];

/** Nav attention badges + Status Board BFF (`leads.newCount`, etc.). */
export async function invalidateStatusBoardQueries(
  queryClient: QueryClient,
): Promise<void> {
  await queryClient.invalidateQueries({
    queryKey: statusBoardQueryKeys.root,
  });
}

export async function invalidateDashboardStatusQueries(
  queryClient: QueryClient,
): Promise<void> {
  await Promise.all(
    DASHBOARD_REFRESH_QUERY_KEYS.map((queryKey) =>
      queryClient.invalidateQueries({ queryKey }),
    ),
  );
}
